export default {
  dark: 'dark',
  darkGrey: 'dark',
  semiTransparent: 'dark',
  semiTransparentDarken: 'dark',
  light: 'light',
};
